import { TableSelectionActionProps } from "./components/SelectionActions";
import { BodyRowProps } from "./components/Table/Body/BodyRow";
import { Column, ExcludedColumn, FetchTableData, TableContainer, TableProps } from "./TableContainer";

export * from "./components/Table/contexts/TableFooterContext";
export * from "./components/Table/Body/RowComponent";

export const Table = TableContainer;

export type {
  ExcludedColumn, Column, FetchTableData, TableProps, TableSelectionActionProps, BodyRowProps,
};

export default Table;
